import { useMemo } from 'react';
import { useAppContext } from '@/components/utilities/AppContext';
import ComponentsRender from '@/components/ComponentsRender';
import { EBOOK } from '@/components/components';
import { buildEbookToc } from '@/utils/ebook-toc';
import { getImagePath } from '@/utils/images';

import EbookBreadcrumb from './EbookBreadcrumb';
import EbookHero from './EbookHero';
import EbookSidebar from './EbookSidebar';
import { EbookChaptersProvider } from './EbookChaptersContext';

const EbookDetailPage = () => {
  const { ebook } = useAppContext();

  const content = useMemo(() => ebook?.content || [], [ebook]);
  const toc = useMemo(() => buildEbookToc(content), [content]);
  const chapterMap = useMemo(
    () => Object.fromEntries(toc.map((item) => [item.id, { anchor: item.anchor, number: item.number, index: item.index }])),
    [toc]
  );

  if (!ebook) return null;

  const pdfUrl = ebook.pdfFile?.url ? getImagePath(ebook.pdfFile) : null;
  const chapterCount = ebook.chapterCount || toc.length;

  return (
    <EbookChaptersProvider value={chapterMap}>
      <section className="ebook-content text-grey-900 bg-white">
        <EbookHero
          eyebrow={ebook.eyebrow}
          headline={ebook.heroHeadline}
          title={ebook.title}
          perex={ebook.perex || ebook.shortDescription}
          publishLabel={ebook.publishLabel}
          chapterCount={chapterCount}
          readingTime={ebook.readingTime}
          pdfUrl={pdfUrl}
          pdfLabel={ebook.pdfLabel}
        />

        <div className="mx-auto w-[90vw] pt-10 pb-4 xl:w-(--container-width)">
          <EbookBreadcrumb title={ebook.title} />
        </div>

        <div className="mx-auto w-[90vw] pt-6 pb-20 xl:w-(--container-width)">
          <div className="grid grid-cols-1 gap-10 xl:grid-cols-[1fr_320px] xl:gap-16">
            <main className="ebook-content min-w-0">
              {content.map((component) => (
                <ComponentsRender key={`${component.id}_${component.__typename}`} type={EBOOK} component={component} />
              ))}
            </main>

            <EbookSidebar
              content={content}
              sidebarCta={ebook.sidebarCta}
              sidebarDownload={ebook.sidebarDownload}
              slug={ebook.slug}
            />
          </div>
        </div>
      </section>
    </EbookChaptersProvider>
  );
};

export default EbookDetailPage;
